import DefaultLayout from "@/views/Layout/DefaultLayout";
import i18n from "@/i18n.js";
import { component } from "@braid/vue-formulate";

const usersMenu = {
    path: "/users",
    component: DefaultLayout,
    meta: {
        title: i18n.t("title.coworkers")
    },
    children: [
        {
            path: "index",
            name: "UsersIndex",
            component: () =>
                import(/* webpackChunkName: "users" */ "@/views/Users/VIndex"),
            meta: {
                title: i18n.t("title.coworkers")
            }
        },
        {
            path: "clock-targets",
            name: "UsersClockTargets",
            component: () =>
                import(
                    /* webpackChunkName: "users" */ "@/views/Users/VClockTargets"
                ),
            meta: {
                title: i18n.t("title.clock_daily_targets")
            }
        }
    ]
};

export default usersMenu;
